import { createSlice } from "@reduxjs/toolkit";

const initialState = { shippings: [], shippingDetails: null };

export const shippingSlice = createSlice({
  name: "shipping",
  initialState,
  reducers: {
    setShippingList: (state = initialState, { payload }) => {
      return {
        ...state,
        shippings: payload,
      };
    },

    setShippingDetails: (state = initialState, { payload }) => {
      return {
        ...state,
        shippingDetails: payload,
      };
    },

    addShipping: (state = initialState, { payload }) => {
      return {
        ...state,
        shippings: [...state.shippings, payload],
      };
    },

    updateShipping: (state = initialState, { payload }) => {
      return {
        ...state,
        shippings: state.shippings.map((shipping) =>
          shipping._id === payload._id ? payload : shipping
        ),
      };
    },

    deleteShipping: (state = initialState, { payload }) => {
      return {
        ...state,
        shippings: state.shippings.filter(
          (shipping) => shipping._id !== payload
        ),
      };
    },
  },
});
